import * as React from 'react';
import { Checkbox } from '@cian/ui-kit/checkbox';
import { Tooltip } from '@cian/ui-kit/tooltip';
import { Faq16 } from '@cian/ui-kit/icons';
import * as styles from './AutoProlong.desktop.css';
import classNames from 'classnames';

interface IAutoProlongDesktopProps {
  value: boolean;
  isDisabled: boolean;
  hint: string;
  onChange(): void;
}

export const AutoProlongDesktop = ({ value, isDisabled, hint, onChange }: IAutoProlongDesktopProps) => {
  const hintIcon = isDisabled ? (
    <Faq16 color="primary_10" display="inline-block" />
  ) : (
    <Tooltip title={<div className={styles['hint']}>{hint}</div>}>
      <Faq16 color="primary_100" cursor="pointer" display="inline-block" />
    </Tooltip>
  );

  return (
    <div className={classNames(styles['wrapper'], isDisabled && styles['disabled'])}>
      <Checkbox
        data-name="AutoProlong"
        label="Автопродление"
        checked={value}
        disabled={isDisabled}
        onChange={onChange}
      />
      <span className={styles['hint_icon']}>{hintIcon}</span>
    </div>
  );
};
